import { useEnsureFrontExternalMessageMutation } from '@/generated/graphql';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';

export const useStoreOpenFrontEmail = () => {
  const { defaultOrgId } = useMeContext();
  const [ensureFrontExternalMessage] = useEnsureFrontExternalMessageMutation({
    ignoreResults: true,
  });

  return async (messageId: string): Promise<string | undefined> => {
    if (!defaultOrgId) return undefined;
    const res = await ensureFrontExternalMessage({
      variables: { input: { organizationId: defaultOrgId, messageId } },
    });
    return res.data?.ensureFrontExternalMessage;
  };
};
